import React, { useEffect, useState } from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { findPoolBySchemeId } from "../../../services/live-interface/dior/dior-interface-service";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { InputNumber } from "../../../components/forms/InputNumber";

const GridLayout = WidthProvider(RGL);

export const DiorSortableStepsList = ({ steps, onReorder, onChangeDuration, onDeleteStep }) => {
  const [layout, setLayout] = useState([]);

  useEffect(() => {
    setLayout(
      (steps || []).map((step, i) => ({
        i: step.id,
        x: 0,
        y: i,
        w: 1,
        h: 1,
      }))
    );
  }, [steps]);

  const handleLayoutChange = (newLayout) => {
    setLayout(newLayout);

    const orderedIds = [...newLayout]
      .sort((a, b) => (a.y ?? 0) - (b.y ?? 0))
      .map((l) => l.i); // <- step.id

    const idToStep = new Map((steps || []).map((s) => [s.id, s]));
    const nextSteps = orderedIds.map((id) => idToStep.get(id)).filter(Boolean);

    onReorder?.(nextSteps);
  };

  return (
    <GridLayout
      className="layout"
      layout={layout}
      cols={1}
      rowHeight={72}           // fixed height mandatory
      margin={[0, 0]}
      containerPadding={[0, 0]}
      isDraggable={true}
      isResizable={false}      // drag only
      resizeHandles={[]}       // ensure no resize handles
      autoSize={true}
      isBounded={false}
      compactType="vertical"
      draggableHandle=".drag-handle"
      onLayoutChange={handleLayoutChange}
      useCSSTransforms={true}
    >
      {(steps || []).map((step) => {
        return (
          <div key={step.id} className="select-none">
            <div className="bg-perception-black-800 rounded-md flex justify-between items-center py-1">
              {/* Pool data */}
              <div className="flex items-center">
                <div className="p-4 cursor-move drag-handle">
                  <span className="text-perception-gray-600 grid grid-cols-2 gap-x-1 gap-y-1">
                    <span className="h-1 w-1 rounded-full bg-current" />
                    <span className="h-1 w-1 rounded-full bg-current" />
                    <span className="h-1 w-1 rounded-full bg-current" />
                    <span className="h-1 w-1 rounded-full bg-current" />
                    <span className="h-1 w-1 rounded-full bg-current" />
                    <span className="h-1 w-1 rounded-full bg-current" />
                  </span>
                </div>

                <div className="text-xs bg-perception-gray-700 text-white px-3 py-0.5 rounded-md mr-2">
                  {step.pool_id}
                </div>

                <div className="p-4 pl-0">{findPoolBySchemeId(step.pool_id).name}</div>
              </div>

              {/* Durations + Delete action */}
              <div className="h-full flex gap-12 items-center pr-4">
                <div className="flex flex-col items-start gap-1">
                  <p className="text-xs">Durações mín./máx. (s)</p>
                  <div className="flex gap-2">
                    <InputNumber value={step.duration_min} setValue={(duration) => onChangeDuration(step.id, 'min', duration)} theme="dark" placeholder="Mín" size="sm" className="w-12"/>
                    <InputNumber value={step.duration_max} setValue={(duration) => onChangeDuration(step.id, 'max', duration)} theme="dark" placeholder="Máx" size="sm" className="w-12"/>
                  </div>
                </div>

                <div className="min-w-8 text-perception-gray-700 hover:text-red-500 cursor-pointer" onClick={() => onDeleteStep(step.id)}>
                  <XMarkIcon className="size-8"/>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </GridLayout>
  );
}